export default "__VITE_ASSET__DcLB$EuM__"